import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const HelpCenter = lazy(()=> import(/* webpackChunkName: "HelpCenter" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/help-center" component={HelpCenter} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/HelpCenter/routes.js